module.exports = __webpack_public_path__ + "img/zoom.de4d05b3.png";